import { createAsyncThunk } from "@reduxjs/toolkit";
import { ContactNote, DeleteParams } from "../model/ContactNote";
import * as services from "../services/contactNoteService";

export const fetchContactNotes = createAsyncThunk("contactNoteList/fetchContactNotes", (contactId: string) =>
    services.fetchContactNotes(contactId)
);

export const fetchContactNoteById = createAsyncThunk("contactNoteList/fetchContactNoteById", (contactNoteId: string) =>
    services.fetchContactNoteById(contactNoteId)
);

export const addOrUpdateContactNote = createAsyncThunk(
    "contactNoteForm/addOrUpdateContactNote",
    (contactNote: ContactNote) => services.addOrUpdateContactNotes(contactNote)
);

export const deleteContactNotes = createAsyncThunk(
    "contactNoteList/deleteContactNotes",
    async (params: DeleteParams): Promise<ContactNote[]> => {
        await services.deleteContactNotes(params.contactNoteIds);
        const contactNotes = services.fetchContactNotes(params.contactId);
        return contactNotes;
    }
);
